import { DISABLE_FOCUS_ON } from 'Jobfeed/store/actions_names';

// eslint-disable-next-line import/prefer-default-export
export const disableFocusOn = () => {
  document.body.classList.remove('FocusOn');
  return { type: DISABLE_FOCUS_ON };
};
